import { useDocuments } from "./useDocuments";
import {
  PRIVACY_QUESTIONNAIRE_CONTENTS,
  SAFETY_QUESTIONNAIRE_CONTENTS,
} from "../components/dynamic/extras/questionnaireContent";

export function useDynamicComponents() {
  const documents = useDocuments();

  const DYNAMIC_COMPONENTS = {
    Become1: {
      name: "Become1 Auswahl",
    },
    BriefingPage: {
      name: "Informations-Dokument",
      props: [
        {
          value: "fileName",
          name: "Dokument",
          type: "SELECT",
          options: documents,
        },
        {
          value: "isOptional",
          name: "Optional?",
          type: "SWITCH",
        },
      ],
    },
    DataAndSignature: {
      name: "Personendaten und Unterschrift",
      unselectable: true,
    },
    DocumentsIntroductionPage: {
      name: "Dokumente Einführungsseite",
    },
    DocumentsMail: {
      name: "Datenexport und Abschluss",
      unselectable: true,
    },
    DriversLicensePage: {
      name: "Führerscheinupload",
      props: [
        {
          value: "skip",
          name: "Überspringbare Schritte",
          type: "NUMBER",
          options: {
            min: 0,
            max: 2,
            step: 1,
          },
        },
      ],
    },
    EditablePdfDocument: {
      name: "Dokument (Unterschrift)",
      props: [
        {
          value: "fileName",
          name: "Dokument",
          type: "SELECT",
          options: documents,
        },
        {
          value: "isOptional",
          name: "Optional?",
          type: "SWITCH",
        },
      ],
    },
    FinishPage: {
      name: "Abschluss",
      unselectable: true,
    },
    FoxAwarenessTrainingPage: {
      name: "Sicherheitsunterweisung (mit Zertifikat)",
      props: [
        {
          value: "image",
          name: "Bild hochladen",
          type: "IMAGE",
        },
        {
          value: "link",
          name: "Anwendungslink",
          type: "TEXT",
        },
      ],
    },
    SafetyIntroductionPage: {
      name: "Sicherheitseinführung Start",
    },
    VideoPage: {
      name: "Video",
      props: [
        {
          value: "questionaireContent",
          name: "Video",
          type: "SELECT",
          options: [
            ...SAFETY_QUESTIONNAIRE_CONTENTS,
            PRIVACY_QUESTIONNAIRE_CONTENTS,
          ],
        },
      ],
    },
  };

  return { DYNAMIC_COMPONENTS };
}
